import { render, staticRenderFns } from "./ZyroLoader.vue?vue&type=template&id=57caae41&scoped=true&"
var script = {}
import style0 from "./ZyroLoader.vue?vue&type=style&index=0&id=57caae41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57caae41",
  null
  
)

export default component.exports